import express from 'express';
import { parsePayload } from '~/app/middleware';

import { callbackHandler } from '../middleware/Callback';
import { updateEntryField } from '../middleware/Fields';

const updateRouter = express.Router();

updateRouter.post(
  '/field{/:preview}',
  parsePayload,
  updateEntryField,
  callbackHandler
);

export default updateRouter;
